import React from "react";
import {IDaTabPanelProps} from "./types";

export const DaTabPanel: React.FC<IDaTabPanelProps<any>> = (
    {
        children,
        selectedIndex,
        index,
    } : IDaTabPanelProps<any>

): JSX.Element => {
  return (
      <div
          role="tabpanel"
          hidden={selectedIndex !== index}
      >
          {
              selectedIndex === index &&
              children
          }
      </div>
  );
};